import React from 'react';
import {IconProps} from './_iconProps';

export const Copy: React.FC<IconProps> = ({
  width=32,
  height=32,
  stroke="currentColor",
  strokeWidth="1.5",
  className
}) =>  <svg className={'icon '+(className||'')} style={{color:stroke}} width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.66667 20H5.33334C4.62609 20 3.94782 19.7191 3.44772 19.219C2.94762 18.7189 2.66667 18.0406 2.66667 17.3334V5.33335C2.66667 4.62611 2.94762 3.94783 3.44772 3.44774C3.94782 2.94764 4.62609 2.66669 5.33334 2.66669H17.3333C18.0406 2.66669 18.7189 2.94764 19.219 3.44774C19.7191 3.94783 20 4.62611 20 5.33335V6.66669M14.6667 12H26.6667C28.1394 12 29.3333 13.1939 29.3333 14.6667V26.6667C29.3333 28.1394 28.1394 29.3334 26.6667 29.3334H14.6667C13.1939 29.3334 12 28.1394 12 26.6667V14.6667C12 13.1939 13.1939 12 14.6667 12Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
</svg>
